import { deliveryChargeAreaService, vworldDataService, } from '@/services';
import { BusinessError, errorCode, } from '@/error';
import { i18n } from '@/locales';
import { IDeliveryChargeAreaActionTypes, IDeliveryChargeAreaMutations, } from './types';
const action = {
    [IDeliveryChargeAreaActionTypes.setSearchValue]({ commit }, payload) {
        commit('SET_SEARCH_VALUE', payload);
    },
    [IDeliveryChargeAreaActionTypes.setEupMyeonDongBoundaryVisibleList]({ commit }, payload) {
        commit('SET_EUP_MYEON_DONG_BOUNDARY_VISIBLE_LIST', payload);
    },
    [IDeliveryChargeAreaActionTypes.setSelectedArea]({ commit }, payload) {
        commit('SET_SELECTED_AREA', payload);
    },
    [IDeliveryChargeAreaActionTypes.setIsCreateAreaMode]({ commit }, isCreateAreaMode) {
        commit('SET_IS_CREATE_AREA_MODE', isCreateAreaMode);
    },
    [IDeliveryChargeAreaActionTypes.setCurrentPolygonCoordinateList]({ commit }, list) {
        commit('SET_CURRENT_POLYGON_COORDINATE_LIST', list);
    },
    [IDeliveryChargeAreaActionTypes.setCurrentPolygonNeedResetList]({ commit }, list) {
        commit('SET_CURRENT_POLYGON_NEED_RESET_LIST', list);
    },
    async [IDeliveryChargeAreaActionTypes.setEupMyeonDongBoundaryInfo]({ commit }, { isDelete, payload }) {
        try {
            if (isDelete) {
                commit('SET_EUP_MYEON_DONG_BOUNDARY_CURRENT_INFO', {
                    isDelete,
                    item: {},
                });
                commit('SET_SEARCH_VALUE', {
                    field: 'dongName',
                    value: '',
                });
                return {
                    isSuccess: true,
                };
            }
            const { dongName, mapCenterCoordinate } = payload;
            const { latitude: y, longitude: x } = mapCenterCoordinate;
            const geomFilter = {
                // 지도 중심에서 사방으로 0.02도(약 2.22km) 넓힌 범위
                min: {
                    x: String(Number(x) - 0.2),
                    y: String(Number(y) - 0.02),
                },
                max: {
                    x: String(Number(x) + 0.2),
                    y: String(Number(y) + 0.02),
                },
            };
            const { response } = await vworldDataService.getEupMyeonDongBoundary({
                dongName,
                geomFilter,
            });
            const lc = 'views.delivery_charge_area_control.';
            if (response.status === 'NOT_FOUND') {
                return {
                    isSuccess: false,
                    message: i18n.t(`${lc}eup_myeon_dong_boundary_not_found`),
                };
            }
            if (response.status === 'ERROR') {
                return {
                    isSuccess: false,
                    message: i18n.t('common.failure'),
                };
            }
            response.result.featureCollection.features.forEach(({ geometry, properties }) => {
                const boundaryCoordinatesList = geometry.coordinates[0][0];
                const { emd_cd: emdCd, emd_kor_nm: areaName } = properties;
                // 법정동 경계 데이터의 areaId가 barogo client api의 areaId와 중복이 될 수 있으므로 이를 막기 위해 기존 코드에 v prefix 추가
                const areaId = `v-${emdCd}`;
                const coordinateList = boundaryCoordinatesList.map(([longitude, latitude,]) => ({
                    latitude,
                    longitude,
                }));
                commit('SET_EUP_MYEON_DONG_BOUNDARY_CURRENT_INFO', {
                    isDelete,
                    item: {
                        areaId,
                        areaName,
                        coordinateList,
                    },
                });
            });
            return {
                isSuccess: true,
                message: i18n.t(`${lc}get_eup_myeon_dong_boundary_success`),
            };
        }
        catch (error) {
            console.log('[deliveryChargeAreaControl/setEupMyeonDongBoundaryInfo]', error);
            let message = i18n.t('common.failure');
            // TODO 현재 400에러 발생 시 위의 BusinessError instanceof 조건에 걸리지 않음, 확인 필요
            if (error instanceof BusinessError) {
                message = error.message;
            }
            if (error.response?.data.error.message) {
                message = error.response?.data.error.message;
            }
            return {
                isSuccess: false,
                message,
            };
        }
    },
    // 등록된 구역 목록 조회
    async [IDeliveryChargeAreaActionTypes.getRegisteredAreaList]({ commit, rootGetters, state }, hubId) {
        try {
            const getterSubscribeHubId = rootGetters['hubSelector/getterSubscribeHubId'];
            const { data } = await deliveryChargeAreaService.getDeliveryChargeAreaList({
                hubId: hubId ?? getterSubscribeHubId,
            });
            // 기존 데이터를 병합한다. (로컬의 coordinateList를 가져와야 한다.)
            const mergeData = data.reduce((acc, it) => {
                const oldItemIndex = state.registeredAreaList.findIndex((oldItem) => oldItem.areaId === it.areaId);
                const oldItem = state.registeredAreaList[oldItemIndex];
                if (oldItem && oldItem.coordinateList) {
                    acc.push({
                        ...it,
                        coordinateList: oldItem.coordinateList,
                    });
                    return acc;
                }
                acc.push(it);
                return acc;
            }, []);
            commit('SET_REGISTERED_AREA_LIST', mergeData);
            return {
                isSuccess: true,
            };
        }
        catch (error) {
            console.log('[deliveryChargeAreaControl/getRegisteredAreaList]', error);
            let message = i18n.t('common.failure');
            // TODO 현재 400에러 발생 시 위의 BusinessError instanceof 조건에 걸리지 않음, 확인 필요
            if (error instanceof BusinessError) {
                message = error.message;
            }
            if (error.response?.data.error.message) {
                message = error.response?.data.error.message;
            }
            return {
                isSuccess: false,
                message,
            };
        }
    },
    async [IDeliveryChargeAreaActionTypes.setCheckedListAreaInfo]({ commit, rootGetters }, { isDelete, areaId, }) {
        try {
            if (isDelete) {
                commit('SET_CHECKED_AREA_LIST', {
                    isDelete,
                    data: {
                        areaId: String(areaId),
                    },
                });
                return {
                    isSuccess: true,
                };
            }
            const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
            const { data } = await deliveryChargeAreaService.getDeliveryChargeArea({
                hubId,
                areaId,
            });
            commit('SET_CHECKED_AREA_LIST', {
                isDelete,
                data,
            });
            return {
                isSuccess: true,
            };
        }
        catch (error) {
            console.log('[deliveryChargeAreaControl/setCheckedListAreaInfo]', error);
            let message = i18n.t('common.failure');
            // TODO 현재 400에러 발생 시 위의 BusinessError instanceof 조건에 걸리지 않음, 확인 필요
            if (error instanceof BusinessError) {
                message = error.message;
            }
            if (error.response?.data.error.message) {
                message = error.response?.data.error.message;
            }
            return {
                isSuccess: false,
                message,
            };
        }
    },
    async [IDeliveryChargeAreaActionTypes.postRegisteredAreaList]({ rootGetters }, areaInfo) {
        try {
            const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
            await deliveryChargeAreaService.postDeliveryChargeArea({
                hubId,
                areaInfo,
            });
            return {
                isSuccess: true,
            };
        }
        catch (error) {
            console.log('[deliveryChargeAreaControl/getRegisteredAreaList]', error);
            let message = i18n.t('common.failure');
            // TODO 현재 400에러 발생 시 위의 BusinessError instanceof 조건에 걸리지 않음, 확인 필요
            if (error instanceof BusinessError) {
                message = error.message;
            }
            if (error.response?.data.error.errorCode) {
                message = errorCode[error.response?.data.error.errorCode];
            }
            return {
                isSuccess: false,
                message,
            };
        }
    },
    async [IDeliveryChargeAreaActionTypes.editClickedAreaName]({ rootGetters }, { areaId, areaName }) {
        try {
            const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
            await deliveryChargeAreaService.putDeliveryChargeArea({
                hubId,
                areaId,
                areaName,
            });
            return {
                isSuccess: true,
            };
        }
        catch (error) {
            console.log('[deliveryChargeAreaControl/editClickedAreaName]', error);
            let message = i18n.t('common.failure');
            // TODO 현재 400에러 발생 시 위의 BusinessError instanceof 조건에 걸리지 않음, 확인 필요
            if (error instanceof BusinessError) {
                message = error.message;
            }
            if (error.response?.data.error.message) {
                message = error.response?.data.error.message;
            }
            return {
                isSuccess: false,
                message,
            };
        }
    },
    async [IDeliveryChargeAreaActionTypes.deleteClickedArea]({ rootGetters }, areaId) {
        try {
            const hubId = rootGetters['hubSelector/getterSubscribeHubId'];
            await deliveryChargeAreaService.deleteDeliveryChargeArea({
                hubId,
                areaId,
            });
            return {
                isSuccess: true,
            };
        }
        catch (error) {
            console.log('[deliveryChargeAreaControl/deleteDeliveryChargeArea]', error);
            let message = i18n.t('common.failure');
            // TODO 현재 400에러 발생 시 위의 BusinessError instanceof 조건에 걸리지 않음, 확인 필요
            if (error instanceof BusinessError) {
                message = error.message;
            }
            if (error.response?.data.error.message) {
                message = error.response?.data.error.message;
            }
            return {
                isSuccess: false,
                message,
            };
        }
    },
    [IDeliveryChargeAreaActionTypes.resetStore]({ commit }) {
        commit('RESET_STORE');
    },
    /**
     * checkedAreaList2
     */
    async setCheckedAreaList2({ rootGetters, commit, state }, value) {
        const hubId = rootGetters['hubSelector/getterSubscribeOnlyHubId'];
        // registeredAreaList에서 coordinate 없는 것들 추리기
        const isNotExistCoordniateList = value.reduce((acc, it) => {
            const index = state.registeredAreaList
                .findIndex((area) => it === area.areaId && !area.coordinateList);
            if (index !== -1) {
                acc.push(state.registeredAreaList[index].areaId);
            }
            return acc;
        }, []);
        // coordinate 없는 것만 요청
        const areaData = [];
        await Promise.all(isNotExistCoordniateList.map(async (areaId) => {
            const { data } = await deliveryChargeAreaService.getDeliveryChargeArea({
                hubId,
                areaId,
            });
            areaData.push(data);
        }));
        // 기존 등록 데이터에 coordinate 정보 업데이트
        const addCoordinateAreaList = state.registeredAreaList.reduce((acc, registeredArea) => {
            let item = registeredArea;
            areaData.forEach((it) => {
                const { coordinateList, areaId, } = it;
                if (areaId === registeredArea.areaId
                    && !registeredArea.coordinateList) {
                    item = {
                        ...registeredArea,
                        coordinateList,
                    };
                }
            });
            acc.push(item);
            return acc;
        }, []);
        commit(IDeliveryChargeAreaMutations.SET_REGISTERED_AREA_LIST, addCoordinateAreaList);
        commit('SET_CHECKED_AREA_LIST2', value);
    },
    async setCheckedAreaList2DeleteById({ commit, state }, areaId) {
        const result = state.checkedAreaList2.filter((itemAreaId) => itemAreaId !== areaId);
        commit('SET_CHECKED_AREA_LIST2', result);
    },
};
export default action;
